import { Pipe, PipeTransform } from '@angular/core';
import { ITimeSeriesInfo } from '../interfaces';

@Pipe({
  name: 'directionCompassRose',
})
export class DirectionCompassRose implements PipeTransform {
  constructor() {}

  transform(input: any, frontendIndex?: number, isCurrents?: boolean): any {
    if (!input || input == undefined || input.length == 0) return null;

    if (frontendIndex)
      var value = input.filter(
        (singleSeries: ITimeSeriesInfo) =>
          singleSeries.indexFrontend == frontendIndex
      )[0].lastValue;
    else value = input;

    if (isCurrents)
      var CompassRoseAngles = [
        { label: 'N', value: 180 },
        { label: 'S', value: 0 },
        { label: 'S', value: 360 },
        { label: 'E', value: 270 },
        { label: 'O', value: 90 },

        { label: 'NE', value: 225 },
        { label: 'SE', value: 315 },
        { label: 'NO', value: 135 },
        { label: 'SO', value: 45 },

        { label: 'NNE', value: 202.5 },
        { label: 'ENE', value: 247.5 },
        { label: 'ESE', value: 292.5 },
        { label: 'SSE', value: 337.5 },
        { label: 'SSO', value: 22.5 },
        { label: 'OSO', value: 67.5 },
        { label: 'ONO', value: 112.5 },
        { label: 'NNO', value: 157.5 },
      ];
    else
      var CompassRoseAngles = [
        { label: 'N', value: 0 },
        { label: 'S', value: 180 },
        { label: 'E', value: 90 },
        { label: 'O', value: 270 },

        { label: 'NE', value: 45 },
        { label: 'SE', value: 135 },
        { label: 'NO', value: 315 },
        { label: 'SO', value: 225 },

        { label: 'NNE', value: 22.5 },
        { label: 'ENE', value: 67.5 },
        { label: 'ESE', value: 112.5 },
        { label: 'SSE', value: 157.5 },
        { label: 'SSO', value: 202.5 },
        { label: 'OSO', value: 247.5 },
        { label: 'ONO', value: 292.5 },
        { label: 'NNO', value: 337.5 },
      ];

    var closest = CompassRoseAngles.reduce((prev, curr) => {
      return Math.abs(curr.value - value) < Math.abs(prev.value - value)
        ? curr
        : prev;
    });

    return closest.label;
  }
}
